export const TIMES_SLOTS = 4;
